module.exports = __webpack_public_path__ + "images/_/assets/images/calendar.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calendar.png
// module id = ./src/assets/images/calendar.png
// module chunks = 1